import { BlockMath, InlineMath } from "react-katex";
import FractionInput from "../../../../components/inputs/FractionInput";
import React from "react";

// === UTIL ===
function getRandomInt(min, max) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

// === GENERATOR ===
export function generateTask() {
  const isFibonacci = Math.random() < 0.1; // 10% szans na Fib

  let a1, a2, k1, k2, r;

  if (isFibonacci) {
    a1 = 1;
    a2 = 1;
    k1 = 1;
    k2 = 1;
    r = 0;
  } else {
    a1 = getRandomInt(1, 9);
    a2 = getRandomInt(1, 9);
    k1 = getRandomInt(1, 6); // ograniczenie zgodnie z założeniem
    k2 = getRandomInt(1, 6);
    r = getRandomInt(-9, 9); // r może być 0 lub ujemny
  }

  const targetIndex = getRandomInt(5, 6); // a₅ lub a₆

  const values = [a1, a2];
  for (let i = 2; i <= targetIndex; i++) {
    const next = k1 * values[i - 2] + k2 * values[i - 1] + r;
    values.push(next);
  }

  return {
    type: "RecursiveTwoStepTask",
    data: {
      a1,
      a2,
      k1,
      k2,
      r,
      targetIndex,
      targetValue: values[targetIndex - 1]
    }
  };
}


// === RENDER ===

export function renderTask({ data }) {
  const { a1, a2, k1, k2, r, targetIndex } = data;

  const k1Part = k1 === 1 ? "a_n" : `${k1}a_n`;
  const k2Part = k2 === 1 ? "a_{n+1}" : `${k2}a_{n+1}`;
  const rPart = r === 0 ? "" : r > 0 ? `+ ${r}` : `- ${Math.abs(r)}`;

  return (
    <div className="space-y-2">
      <p>Dany jest ciąg określony rekurencyjnie:</p>
      <BlockMath math={`\\begin{cases}a_1=${a1},\\\\a_2=${a2},\\\\a_{n+2}=${k1Part}+${k2Part} ${rPart} & \\text{dla } n\\ge 1.\\end{cases}`} />
      <p>Oblicz wyraz <InlineMath math={`a_{${targetIndex}}`} /> tego ciągu.</p>
    </div>
  );
}


export function renderInput({ data }, userAnswer, onChange, disabled) {
  const { targetIndex } = data;

  return (
    <FractionInput
      label={`a_{${targetIndex}}`}
      value={userAnswer}
      onChange={onChange}
      disabled={disabled}
    />
  );
}

export function checkAnswer({ data }, userAnswer) {
  if (!userAnswer || typeof userAnswer !== "object") return false;

  const given = userAnswer.parsed;
  if (given === null) return false;

  // 👇 DODAJEMY informację o indeksie
  userAnswer.n = data.targetIndex;

  return given === data.targetValue;
}

export function renderAnswer({ data }) {
  return <InlineMath math={`a_{${data.targetIndex}} = ${data.targetValue}`} />;
}

export function renderExplanation({ data }) {
  const { a1, a2, k1, k2, r, targetIndex, targetValue } = data;

  const k1Part = k1 === 1 ? "a_n" : `${k1}a_n`;
  const k2Part = k2 === 1 ? "a_{n+1}" : `${k2}a_{n+1}`;
  const rPart = r === 0 ? "" : r > 0 ? `+ ${r}` : `- ${Math.abs(r)}`;

  const values = [a1, a2];
  const steps = [];

  steps.push(
    <div key="wzor">
      <strong>Wzór rekurencyjny:</strong>
      <BlockMath math={`\\begin{cases}a_1=${a1},\\\\a_2=${a2},\\\\a_{n+2}=${k1Part}+${k2Part} ${rPart} & \\text{dla } n\\ge 1.\\end{cases}`} />
    </div>
  );

  for (let i = 3; i <= targetIndex; i++) {
    const prev2 = values[i - 3];
    const prev1 = values[i - 2];
    const next = k1 * prev2 + k2 * prev1 + r;
    values.push(next);

    const rStr = r === 0 ? "" : r > 0 ? ` + ${r}` : ` - ${Math.abs(r)}`;
    steps.push(
      <div key={`step${i}`}>
        <strong>Krok {i - 2}:</strong>{" "}
        <BlockMath math={`a_{${i}} = ${k1} \\cdot ${prev2} + ${k2} \\cdot ${prev1}${rStr} = ${next}`} />
      </div>
    );
  }

  steps.push(
    <div key="final">
      <strong>Odpowiedź:</strong>
      <BlockMath math={`a_{${targetIndex}} = ${targetValue}`} />
    </div>
  );

  return <div className="space-y-3" style={{ textAlign: "left" }}>{steps}</div>;
}

export function renderUserAnswer(userAnswer, task) {
  const n = userAnswer?.n ?? task?.data?.targetIndex ?? "?";


  if (!userAnswer || typeof userAnswer !== "object" || !userAnswer.raw) {
    return <i>(brak odpowiedzi)</i>;
  }

  return <InlineMath math={`a_{${n ?? "?"}} = ${userAnswer.raw}`} />;
}

